var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer-main"},[_c('footer-routes'),_c('footer-contact')],1)]),_c('footer-copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }